export default __webpack_public_path__ + "static/media/gallery_04.94ef38a9.jpg";